import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { ERROR_PAGE } from '@app/constants/page'

export const useErrorRedirect = (isError: boolean): void => {
  const navigate = useNavigate()

  useEffect(() => {
    if (isError) {
      navigate(ERROR_PAGE)
    }
  }, [isError])
}
